module.exports = __webpack_public_path__ + "img/sütünlar.40e67421.png";